import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, gradient, skinOutline, fill, outline }) {
  const randomGradientId1 = `_${useRandomId()}`

  return (
    <g transform={`scale(${scaleX},1)`}>
      <path
        d="M78.0603 43.7823C78.0603 43.7823 60.2304 34.4723 56.1804 29.7323C51.6804 24.4723 51.8804 1.83228 51.8804 1.83228H39.4604C39.4604 1.83228 39.7704 24.5823 35.1604 29.7323C30.2704 35.1923 13.1104 43.4423 13.1104 43.4423C19.3004 58.0223 36.1303 59.4423 45.6703 59.4423C55.2104 59.4423 71.8603 58.3723 78.0603 43.7823Z"
        fill={`url(#${randomGradientId1})`}
        stroke={skinOutline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M89.1504 72.0322C89.1604 72.0322 89.1604 72.0322 89.1504 72.0322V72.0322Z"
        fill="#F2F2F2"
        stroke="#D3D3D3"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M77.36 42.5723C77.36 42.5723 66.44 55.6323 45.58 55.6323C24.72 55.6323 13.8 42.5723 13.8 42.5723C9.13 44.7723 5.63 48.1923 3.92 59.1023C2.26 69.7023 2 72.0323 2 72.0323H89.15C89.15 72.0323 88.86 69.6623 87.23 59.1023C85.5 47.8523 82.02 44.7823 77.36 42.5723Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <defs>
        <linearGradient
          id={randomGradientId1}
          x1="45.5819"
          y1="26.2272"
          x2="45.5819"
          y2="9.49607"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1476" stopColor={gradient[1]} />
          <stop offset="0.8447" stopColor={gradient[0]} />
        </linearGradient>
      </defs>
    </g>
  )
}
